import React from "react";
import { FaTimes, FaTools, FaCogs, FaUniversity, FaImages, FaEnvelope } from "react-icons/fa";
import { Link } from "react-router-dom";

const Sidebar = ({ isOpen, toggle }) => {
  return (
    <div
      className={`fixed top-0 left-0 w-full h-full bg-gradient-to-br from-purple-900 via-gray-900 to-black 
      transform ${isOpen ? "translate-x-0" : "-translate-x-full"} 
      transition-transform duration-500 ease-in-out z-50 flex flex-col`}
    >
      {/* Close Button */}
      <div className="flex justify-end p-6">
        <button
          onClick={toggle}
          className="text-white text-3xl hover:text-pink-400 transition-transform transform hover:rotate-90 duration-300"
        >
          <FaTimes />
        </button>
      </div>

      {/* Sidebar Links */}
      <div className="flex flex-col items-center justify-center flex-1 space-y-10 text-white text-2xl font-semibold">
        
        <a
          href="/#Workshops"
          className="flex items-center gap-3 hover:text-pink-400 hover:scale-110 transition-transform duration-300"
          onClick={toggle}
        >
          <FaTools /> Workshops
        </a>

        <a
          href="/#Events"
          className="flex items-center gap-3 hover:text-blue-400 hover:scale-110 transition-transform duration-300"
          onClick={toggle}
        >
          <FaCogs /> Technical Events
        </a>

        <a
          href="https://jntuacep.ac.in"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 hover:text-green-400 hover:scale-110 transition-transform duration-300"
          onClick={toggle}
        >
          <FaUniversity /> College Details
        </a>

        <a
          href="/#memories"
          className="flex items-center gap-3 hover:text-yellow-400 hover:scale-110 transition-transform duration-300"
          onClick={toggle}
        >
          <FaImages /> Memories
        </a>

        <a
          href="/#contact"
          className="flex items-center gap-3 hover:text-red-400 hover:scale-110 transition-transform duration-300"
          onClick={toggle}
        >
          <FaEnvelope /> Contact Us
        </a>

        <Link
          to="/2k24"
          className="flex items-center gap-3 hover:text-purple-400 hover:scale-110 transition-transform duration-300"
          onClick={toggle}
        >
          <FaImages /> Gallery 2K24
        </Link>
      </div>

      {/* Footer Branding */}
      <div className="text-center pb-6 text-gray-400 text-sm">
        © {new Date().getFullYear()} Yantra 2K25 | All Rights Reserved
      </div>
    </div>
  );
};

export default Sidebar;
